import { FilterOptions, OrdersFilters } from '@/types/orders.types';
import { Filters } from '../OrderNumberDialog';

export type ActiveFilter = { key: string; value: string; id?: number };

export const getActiveFilters = (filters: OrdersFilters, filterOptions?: FilterOptions): ActiveFilter[] => {
  const result: ActiveFilter[] = [];
  if (!filterOptions) return result;

  if (filters.division_id) {
    const division = filterOptions.divisions.find(d => d.id === filters.division_id);
    if (division) result.push({ key: 'division', value: division.name });
  }

  if (Array.isArray(filters.legal_entity_id) && filters.legal_entity_id.length > 0) {
    filters.legal_entity_id.forEach(id => {
      const entity = filterOptions.legal_entities.find(e => e.id === id);
      if (entity) result.push({ key: 'legal_entity', value: entity.name, id: entity.id });
    });
  }

  if (filters.date_from) result.push({ key: 'date_from', value: filters.date_from });
  if (filters.date_to) result.push({ key: 'date_to', value: filters.date_to });

  return result;
};

/**
 * Formats a date string to localized date and time representation
 * Converts ISO 8601 format to Ukrainian locale with Europe/Kiev timezone
 *

 */
export const formatDateTime = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleString('uk-UA', {
      timeZone: 'Europe/Kiev'
    });
  } catch {
    return dateString;
  }
};

export const getFiltersAfterRemove = (filters: OrdersFilters, key: string, id?: number): OrdersFilters => {
  switch (key) {
    case 'division':
      return { ...filters, division_id: undefined, legal_entity_id: undefined };
    case 'legal_entity':
      return {
        ...filters,
        legal_entity_id:
          typeof id === 'number' && Array.isArray(filters.legal_entity_id)
            ? filters.legal_entity_id.filter(entityId => entityId !== id)
            : undefined
      };
    case 'date_from':
      return { ...filters, date_from: '' };
    case 'date_to':
      return { ...filters, date_to: '' };
    default:
      return filters;
  }
};

export const getNextFilters = (
  filters: OrdersFilters,
  prop: keyof OrdersFilters,
  value?: string | number | number[]
) => {
  switch (prop) {
    case 'division_id':
      return {
        ...filters,
        division_id: typeof value === 'number' ? value : undefined,
        legal_entity_id: undefined
      };
    case 'legal_entity_id':
      return {
        ...filters,
        legal_entity_id: Array.isArray(value) ? value : undefined
      };
    case 'date_from':
      return {
        ...filters,
        date_from: typeof value === 'string' ? value : ''
      };
    case 'date_to':
      return {
        ...filters,
        date_to: typeof value === 'string' ? value : ''
      };
    default:
      return filters;
  }
};

export const defaultFilters: OrdersFilters = {
  division_id: undefined,
  legal_entity_id: undefined,
  date_from: '',
  date_to: ''
};

export const defaultOrderFilters: Filters = {
  divisionId: undefined,
  legalEntityId: undefined
};

export const getNextDialogFilters = (
  filters: Filters,
  prop: 'divisionId' | 'legalEntityId',
  value?: string | number
): Filters => {
  if (prop === 'divisionId') {
    return typeof value === 'number' ? { divisionId: value, legalEntityId: undefined } : defaultOrderFilters;
  }
  if (prop === 'legalEntityId') {
    return typeof value === 'number' ? { ...filters, legalEntityId: value } : { ...filters, legalEntityId: undefined };
  }
  return filters;
};
